export const interactiveTypes = [
  {
    label: 'Field Check',
    name: 'field-check',
  },
  {
    label: 'Hotspot',
    name: 'hotspot'
  },
  {
    label: 'Progression',
    name: 'progression',
  },
  {
    label: 'Simulation',
    name: 'simulation'
  },
  {
    label: 'Slider',
    name: 'slider'
  },
  {
    label: 'Timeline',
    name: 'timeline'
  }
]

export const iconSetOptions = [
  {
    label: 'Solid',
    value: 's'
  },
  {
    label: 'Brands',
    value: 'b'
  },
]

export const basicRTEControls = ['bold', 'italic', 'underline','bulletList', 'numberList', 'link'];